import { FormSwitcher } from '@component/form-switcher/form-switcher';
import { Form } from '@form/common.style';
import { BaseFormInterface } from '@interface/form/base-form.interface';

interface IntegrationAuthFormProps extends BaseFormInterface {
  onEnable: (enabled: boolean) => void;
}

export const IntegrationAuthForm = ({ form, onEnable }: IntegrationAuthFormProps) => (
  <Form form={form}>
    <Form.Item label='Enable' name='enabled' rules={[{ required: true }]}>
      <FormSwitcher form={form} name='enabled' onChange={onEnable} />
    </Form.Item>
  </Form>
);
